import { formatCurrency } from '../../helpers/formatCurrency';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import EmptyState from 'components/EmptyState';

import CartLineItem from 'pages/MaintenancePage/components/CartLineItem';
import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const CartPanel: FunctionComponent<Props> = ({
    cart,
    className = '',
    isOpen,
    itemCount,
    onClose,
    onDecrement,
    onIncrement,
    onPlaceOrder,
    onRemove,
    orderPoNumber,
    subtotal,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const openClass = isOpen ? styles.isOpen : '';

    return (
        <Wrapper className={className}>
            <Wrapper className={`${styles.scrim} ${openClass}`} onClick={onClose} />

            <VerticalContainer className={`${styles.cartPanel} ${openClass}`} testId={testId}>
                <HorizontalContainer className={styles.cartPanelHead}>
                    <Wrapper
                        className={
                            styles.cartPanelTitle
                        }>{`${t.CART_TITLE} · ${itemCount}`}</Wrapper>

                    <Wrapper className={styles.drawerClose} onClick={onClose}>
                        ×
                    </Wrapper>
                </HorizontalContainer>

                <VerticalContainer className={styles.cartPanelBody}>
                    {cart.length === 0 ? (
                        <EmptyState text={t.EMPTY_CART} />
                    ) : (
                        cart.map(line => (
                            <CartLineItem
                                key={line.partId}
                                line={line}
                                onDecrement={onDecrement}
                                onIncrement={onIncrement}
                                onRemove={onRemove}
                            />
                        ))
                    )}
                </VerticalContainer>

                <VerticalContainer className={styles.cartPanelFoot}>
                    {orderPoNumber ? (
                        <VerticalContainer className={styles.orderSuccess}>
                            <Wrapper>{t.ORDER_PLACED}</Wrapper>

                            <Wrapper
                                className={styles.orderSuccessPo}>{`PO ${orderPoNumber}`}</Wrapper>
                        </VerticalContainer>
                    ) : (
                        <VerticalContainer>
                            <HorizontalContainer className={styles.cartSubtotal}>
                                <Wrapper>{t.SUBTOTAL}</Wrapper>

                                <Wrapper className={styles.cartSubtotalAmount}>
                                    {formatCurrency(subtotal)}
                                </Wrapper>
                            </HorizontalContainer>

                            <Wrapper className={styles.placeOrderBtn} onClick={onPlaceOrder}>
                                {t.PLACE_ORDER}
                            </Wrapper>
                        </VerticalContainer>
                    )}
                </VerticalContainer>
            </VerticalContainer>
        </Wrapper>
    );
};

export default CartPanel;
